import { FunctionComponent } from 'react';

import Button from 'components/layout/Button';
import LayoutContainer, { Sizes } from 'components/layout/LayoutContainer';

import StyledComponent from './styles';
import { Props } from './types';

const PublicPageJobSectionJobBlocksJobLocation: FunctionComponent<Props> = ({
    headline,
    jobCity,
    buttonProps,
}) => {
    return (
        <StyledComponent
            className="public-page-job-section-job-blocks-job-location"
        >
            <LayoutContainer size={Sizes.Small}>
                <div
                    className="headline"
                    dangerouslySetInnerHTML={{ __html: headline }}
                />
                <div className="location">
                    <div
                        className="address"
                        dangerouslySetInnerHTML={{ __html: jobCity?.companyFullAddress }}
                    />
                    {jobCity?.googleMapLink && (
                        <Button
                            className="road-button"
                            href={jobCity?.googleMapLink}
                            {...buttonProps?.road}
                        />
                    )}
                </div>
            </LayoutContainer>
        </StyledComponent>
    );
};

export default PublicPageJobSectionJobBlocksJobLocation;
